module.exports = __webpack_public_path__ + "img/1557614078368751618.9e4c0e6e.png";